module.exports = __webpack_public_path__ + "static/media/role.813f3577.svg";